import React from 'react';
import { Box, Stack } from '@mui/material';
import { Agent } from '@marageti/z4-sdk/lib/people';
import UserProfileAvatar from './UserProfileAvatar';
import UserProfileDetailsWrapper, { ContextMenuCompleteProps } from './UserProfileDetailsWrapper';

type UserProfileProps = {
  agent: Agent;
  contextMenuProps?: ContextMenuCompleteProps;
  agentMutateHandler: (updatedAgent: Agent) => void
};

const UserProfile = ({
  agent,
  contextMenuProps = undefined,
  agentMutateHandler,
}: UserProfileProps) => (
  <Stack direction="column" spacing={3}>
    <Box display="flex" justifyContent="center">
      <UserProfileAvatar agent={agent} agentMutateHandler={agentMutateHandler} />
    </Box>
    <UserProfileDetailsWrapper agent={agent} contextMenuProps={contextMenuProps} />
  </Stack>
);

export default UserProfile;
